import { createFileRoute, useParams } from '@tanstack/react-router'
import { CollectionPage } from '~/components/catalog/collection-page'

export const Route = createFileRoute(
  '/_authenticated/$workspaceSlug/products/collection/$brandSlug/$collectionSlug'
)({
  component: CollectionRoute,
})

function CollectionRoute() {
  const { brandSlug, collectionSlug } = useParams({
    from: '/_authenticated/$workspaceSlug/products/collection/$brandSlug/$collectionSlug',
  })
  return (
    <CollectionPage
      brandSlug={brandSlug}
      collectionSlug={collectionSlug}
      key={`${brandSlug}/${collectionSlug}`}
    />
  )
}
